import axios from "axios";
import { REACT_APP_APIS } from "../config/api";

const client = axios.create({
    baseURL: REACT_APP_APIS,
    headers:{
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});


export {client};